import { h } from "preact";
import i18n from "../i18n";

export default function TaskFooter(props) {
  return (
    <div class="screenPadding">
      <div class="task-footer">
        <div class="row">
          <div class={props.innerClass}>
            <span class="task-footer__section">
              {i18n.t("footer.copyright")}
            </span>
            <a
              href={`mailto:${i18n.t("feedback_mail")}`}
              class="task-footer__section subtle"
            >
              {i18n.t("footer.feedback")}
            </a>
            <a href="/imprint" class="task-footer__section subtle">
              {i18n.t("footer.imprint")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
